import { useRouter } from 'next/router';

import { gotoShopHome, useCatalogProductIdParams, usePdpBaseInfo, usePdpConfig } from '@domains/pdp-common';

export const useStoreDealBannerService = () => {
  const router = useRouter();
  const { isZigzagApp } = usePdpConfig();

  const param = useCatalogProductIdParams();
  const {
    shop,
    brand_home,
    product: { store_deal_banner },
  } = usePdpBaseInfo(param);
  const seller_home = brand_home ?? shop;

  const onClickTitle = () => {
    if (isZigzagApp) {
      gotoShopHome(seller_home.main_domain, seller_home.url, 'product_detail');
    } else {
      router.push(`/${seller_home.main_domain}`);
    }
  };

  return {
    store_deal_banner,
    onClickTitle,
  };
};
